import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsNewPaywall = () => {
	const { userTags } = useUserTags();

	return userTags.includes(tags.newPaywall);
};
